const BH = {
  ibanLength: 22,
};
export { BH };
